<template>
  <div class="list-check-wrap">
    <div class="table-wrap">
      <div class="table-item" style="width: 62%; maring-right: 10px">
        <div class="table-header">
          <span class="header-text">名称</span>
          <span class="header-text">操作</span>
        </div>
        <el-input placeholder="搜索" v-model="searchkey" style="margin: 5px 10px; width: 475px" clearable @change="handleSearch"></el-input>
        <div class="table-content" style="overflow: auto">
          <div class="item-line" v-for="item of dataList" :key="item.regionId">
            <div class="item-col" style="font-weight: 600">
              {{ item.regionName }}（{{ item.countryCode }}）
              <span style="color: darkgray; font-weight: 400; margin-left: 8px">{{ item.targetType }}</span>
            </div>

            <span style="width: 65px; flex-shrink: 0" class="item-col btn-col">
              <el-button
                type="text"
                class="check-btn"
                :disabled="!!alreadyCampaignId || selectItem.includeList.find((dataItem) => dataItem.regionId === item.regionId) ? true : false"
                @click="checkItem(item, 'dx')"
                >定向</el-button
              >
              <el-button
                type="text"
                class="check-btn"
                :disabled="!!alreadyCampaignId || selectItem.excludeList.find((dataItem) => dataItem.regionId === item.regionId) ? true : false"
                @click="checkItem(item, 'pc')"
                >排除</el-button
              >
            </span>
          </div>
        </div>
      </div>
      <div class="table-item" style="width: 35%">
        <div class="table-header">
          <span class="header-text">已选</span>
          <el-button type="text" class="header-text" @click="showBatchExportModal">批量导入</el-button>
          <el-button type="text" class="header-text" @click="clearAllList">清除</el-button>
        </div>
        <div class="table-content">
          <ul class="kind-list">
            <li :class="['kind-item', curShow === 'dx' ? 'cur' : '']" @click="curShow = 'dx'">定向({{ selectItem.includeList.length }})</li>
            <li :class="['kind-item', curShow === 'pc' ? 'cur' : '']" @click="curShow = 'pc'">排除({{ selectItem.excludeList.length }})</li>
          </ul>
          <div class="select-kind-wrap">
            <div class="data-list" v-show="curShow === 'dx'">
              <div class="data-item" v-for="item of selectItem.includeList" :key="item.regionId">
                {{ item.regionName }}<i class="el-icon-close close-btn" @click="deleteItem(item)" v-if="!alreadyCampaignId"></i>
              </div>
            </div>
            <div class="data-list" v-show="curShow === 'pc'">
              <div class="data-item" v-for="item of selectItem.excludeList" :key="item.regionId">
                {{ item.regionName }}<i @click="deleteItem(item)" class="el-icon-close close-btn" v-if="!alreadyCampaignId"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="批量导入" :close-on-click-modal="false" :visible.sync="dialogVisible" width="616px" :append-to-body="true">
      <div class="modal-body">
        <el-radio-group v-model="batchType" size="mini">
          <el-radio-button label="dx">定向</el-radio-button>
          <el-radio-button label="pc">排除</el-radio-button>
        </el-radio-group>
        <el-input style="margin-top: 8px" resize="none" type="textarea" :rows="5" placeholder="支持以2位地区代码批量导入，以英文逗号" v-model="batchArea">
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmBatch">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getGoogleGeoList, importGoogleGeo } from "@/api/promotion-google.js";
import { mapState } from "vuex";
export default {
  name: "ListCheckWrap",
  props: {},
  data() {
    return {
      curShow: "dx",
      searchkey: "",
      selectItem: {
        includeList: [],
        excludeList: [],
      },
      pageData: {
        total: 0,
        size: 20,
        page: 1,
      },
      dataList: [],
      preData: [],
      dialogVisible: false,
      batchType: "dx",
      batchArea: "",
    };
  },
  mounted() {
    this.initSelect();
    this.dataList = [];
    this.preData = [];
    const scrollBar = document.querySelector(".table-content");
    scrollBar.onscroll = () => {
      const scrollHeight = scrollBar.scrollHeight;
      const scrollTop = scrollBar.scrollTop;
      const clientHeight = scrollBar.clientHeight;
      if (scrollHeight - clientHeight === scrollTop) {
        // 滚动条到最底部
        if (this.preData.length > 0) {
          this.initSelect();
        }
      }
    };
  },
  methods: {
    clearAllList() {
      this.selectItem.excludeList = [];
      this.selectItem.includeList = [];
      this.$emit("selectChange");
    },
    initSelect() {
      getGoogleGeoList({
        id: this.dataList[this.dataList.length - 1]?.id,
        pageSize: this.pageData.size,
        search: this.searchkey,
      }).then((res) => {
        this.preData = res.data;
        this.dataList = this.dataList.concat(res.data);
      });
    },
    deleteItem(item) {
      if (this.curShow === "dx") {
        let delIndex = this.selectItem.includeList.findIndex((dataItem) => dataItem.regionId === item.regionId);
        this.selectItem.includeList.splice(delIndex, 1);
      } else {
        let delIndex = this.selectItem.excludeList.findIndex((dataItem) => dataItem.regionId === item.regionId);
        this.selectItem.excludeList.splice(delIndex, 1);
      }
      this.$emit("selectChange");
    },
    handleSearch() {
      this.dataList = [];
      this.preData = [];
      this.initSelect();
    },
    checkItem(dataItem, type) {
      if (type === "dx") {
        let pcIndex = this.selectItem.excludeList.findIndex((item) => item.regionId === dataItem.regionId);
        if (pcIndex !== -1) {
          this.selectItem.excludeList.splice(pcIndex, 1);
        }
        this.selectItem.includeList.push(dataItem);
        this.curShow = "dx";
      } else {
        let dxIndex = this.selectItem.includeList.findIndex((item) => item.regionId === dataItem.regionId);
        if (dxIndex !== -1) {
          this.selectItem.includeList.splice(dxIndex, 1);
        }
        this.selectItem.excludeList.push(dataItem);
        this.curShow = "pc";
      }
      this.$emit("selectChange");
    },
    showBatchExportModal() {
      this.batchArea = "";
      this.dialogVisible = true;
    },
    confirmBatch() {
      importGoogleGeo([this.batchArea]).then((res) => {
        if (res.data?.length > 0) {
          const data = res.data[0];
          data.map((item) => {
            let dxIndex = this.selectItem.includeList.findIndex((dataItem) => dataItem.regionId === item.regionId);
            let pcIndex = this.selectItem.excludeList.findIndex((dataItem) => dataItem.regionId === item.regionId);
            if (dxIndex === -1 && pcIndex === -1) {
              this.batchType === "dx" ? this.selectItem.includeList.push(item) : this.selectItem.excludeList.push(item);
            }
          });
        }
        this.dialogVisible = false;
      });
    },
  },
  computed: {
    ...mapState({
      alreadyCampaignId: (state) => state.PromotionGoogle.draftCampaign.campaignId,
    }),
  },
};
</script>

<style lang="less" scoped>
.list-check-wrap {
  width: 800px;
  .table-wrap {
    display: flex;
    justify-content: space-between;
    margin-top: 16px;
    .table-item {
      border-radius: 2px;
      border: 1px solid rgba(0, 0, 0, 0.15);
      .table-header {
        display: flex;
        background: rgba(0, 0, 0, 0.02);
        border-bottom: 1px solid rgba(0, 0, 0, 0.15);
        justify-content: space-between;
        line-height: 18px;
        .header-text {
          display: inline-block;
          width: 80px;
          text-align: center;
          padding: 12px 0;
          // color: rgba(0, 0, 0, 0.85);
          font-size: 14px;
        }
      }
      .table-content {
        height: 300px;
        display: flex;
        flex-direction: column;
        &::-webkit-scrollbar {
          width: 4px;
        }
        &::-webkit-scrollbar-thumb {
          border-radius: 10px;
          -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
          background: rgba(0, 0, 0, 0.2);
        }
        .kind-list {
          padding: 0px;
          margin: 0px;
          list-style: none;
          display: flex;
          justify-content: space-around;
          border-bottom: 1px solid rgba(0, 0, 0, 0.2);
          line-height: 18px;
          .kind-item {
            color: rgba(0, 0, 0, 0.65);
            font-size: 14px;
            padding: 12px 0;
            text-align: center;
            border-bottom: 2px solid transparent;
            cursor: pointer;
            &.cur {
              color: rgba(24, 144, 255, 1);
              border-bottom: 2px solid rgba(24, 144, 255, 1);
            }
          }
        }
        .select-kind-wrap {
          height: 100%;
          overflow: auto;
          .data-list {
            .data-item {
              box-sizing: border-box;
              padding: 5px 10px;
              line-height: 16px;
              font-size: 12px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              position: relative;
              .close-btn {
                position: absolute;
                right: 10px;
                top: 8px;
                cursor: pointer;
              }
              &:hover {
                background-color: #f9f9f9;
              }
            }
          }
        }
        .item-line {
          display: flex;
          padding: 5px 20px;
          line-height: 16px;
          &:hover {
            background-color: #f9f9f9;
          }
          .item-col {
            font-size: 12px;
            display: inline-block;
            width: 100%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .btn-col {
            display: flex;
            justify-content: space-between;
            .check-btn {
              cursor: pointer;
              color: #1890ff;
              padding: 0px;
              margin: 0px;
              font-size: 12px;
              &:disabled {
                color: #b1b1b1;
              }
            }
          }
        }
      }
    }
  }
}
</style>
